
import * as plotUtil from '../plot_util'
import { getAttackArrowHeadPoints, getAttackArrowBodyPoints } from './attack_arrow'
/** 燕尾进攻箭头 */
const tailed_attack_arrow_opts = {
    headHeightFactor: 0.18,
    headWidthFactor: 0.3,
    neckHeightFactor: 0.85,
    neckWidthFactor: 0.15,
    headTailFactor: 0.8,
    tailWidthFactor: 0.1,
    swallowTailFactor: 1
}

export default function (coordinates) {
    if (coordinates.length < 3) return [coordinates];
    let [tailLeft, tailRight] = coordinates;
    if (plotUtil.isClockWise(coordinates[0], coordinates[1], coordinates[2])) {
        tailLeft = coordinates[1];
        tailRight = coordinates[0];
    }
    let midTail = plotUtil.mid(tailLeft, tailRight);
    let bonePnts = [midTail].concat(coordinates.slice(2));
    // 计算箭头
    let headPnts = getAttackArrowHeadPoints(bonePnts, tailLeft, tailRight);
    let neckLeft = headPnts[0];
    let neckRight = headPnts[4];
    let tailWidth = plotUtil.distance(tailLeft, tailRight);
    let allLen = plotUtil.getBaseLength(bonePnts);
    let len = allLen * tailed_attack_arrow_opts.tailWidthFactor * tailed_attack_arrow_opts.swallowTailFactor;
    const swallowTailPnt = plotUtil.getThirdPoint(bonePnts[1], bonePnts[0], 0, len, true);
    let factor = tailWidth / allLen;
    let bodyPnts = getAttackArrowBodyPoints(bonePnts, neckLeft, neckRight, factor);
    let count = bodyPnts.length;
    let leftPnts = [tailLeft].concat(bodyPnts.slice(0, count / 2));
    leftPnts.push(neckLeft);
    let rightPnts = [tailRight].concat(bodyPnts.slice(count / 2, count));
    rightPnts.push(neckRight);

    leftPnts = plotUtil.getQBSplinePoints(leftPnts);
    rightPnts = plotUtil.getQBSplinePoints(rightPnts);
    return [leftPnts.concat(headPnts, rightPnts.reverse(), [swallowTailPnt])];
}